export const ACC_ROUTES = {
  LOGIN: "/account/login",
  FORGOT_PASSWORD: "/account/forgot-password",
  PASSWORD_RESET: "/account/password-reset",
  CHANGE_PASSWORD: "/account/change-password",
  REGISTER: "/account/register",
  PROFILE: "/Webuser/profile"
};

export const ENQUIRY_ROUTES = {
  LIST: "/enquiry/list",
  EXPORT: "/enquiry/export",
  DETAIL: "/enquiry/detail",
  DETAIL_SAVE: "/enquiry/detail/save",
  COURSE_ADD: "/enquiry/course/add",
  DELETE: "/enquiry/delete"
};

export const FOLLOWUP_ROUTES = {
  LIST: "/follow-up/list",
  STATUS_UPDATE:"/follow-up/update-status",
  DETAIL:"/follow-up/detail",
  DETAIL_SAVE:"/follow-up/detail"
};

export const CATEGORY_ROUTES = {
  LIST: "/category/list",
  DETAIL:"/category/detail",
  DETAIL_SAVE:"/category/detail",
  DELETE: "/category/delete"
};

export const COURSE_ROUTES = {
  LIST: "/course/list",
  DETAIL:"/course/detail",
  DETAIL_SAVE:"/course/detail",
  DELETE: "/course/delete"
};

export const COMMON_ROUTES = {
  DDL_LIST: "/dropdown/list",
  DASHBOARD: "/dashboard/graph/data",
  STUDENTLIST:"/students-list"
};

export const WEBUSER_ROUTES = {
  LIST: "/Webuser/{userType}/user-list",
  DETAIL:"/Webuser/{userType}/detail",
  DETAIL_SAVE: "/Webuser/{userType}/detail/save/{id}",
  DELETE: "/Webuser/delete",
  PROFILE: "/account/profile"
};

export const BED_ROUTES = {
  LIST: "/bed/list",
  DETAIL:"/bed/detail",
  DETAIL_SAVE: "/bed/detail/save",
  DELETE: "/bed/delete",
};